// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Input, PasswordInput } from '@/ui';
import { Form, FormItem } from '@/components';
import { FormWrapper, StyledButton, StyledLinkBlock, StyledTitle } from '../Styled';

// Helpers
import { AuthFieldsNames, TLogInFormValues } from '../../helpers/types';
import { useSignInRules } from '../../hooks/useValidationRules';

interface ILogInForm {
  handleSubmit: (values: TLogInFormValues) => void;
  openForgotPassword: () => void;
  isLoading: boolean;
}

const LogInForm = ({ handleSubmit, isLoading, openForgotPassword }: ILogInForm) => {
  const { t } = useTranslation(['auth', 'common']);
  const rules = useSignInRules();

  const placeholder = t('common_placeholder_input', { ns: 'common' });

  return (
    <FormWrapper>
      <StyledTitle>{t('auth_greeting')}</StyledTitle>

      <Form onFinish={handleSubmit} noValidate>
        <FormItem name={AuthFieldsNames.EMAIL} label={t('auth_email')} rules={rules[AuthFieldsNames.EMAIL]}>
          <Input placeholder={placeholder} type="email" />
        </FormItem>

        <FormItem name={AuthFieldsNames.PASSWORD} label={t('auth_password')} rules={rules[AuthFieldsNames.PASSWORD]}>
          <PasswordInput placeholder={placeholder} />
        </FormItem>

        <StyledButton type="primary" htmlType="submit" loading={isLoading}>
          {t('auth_log_in')}
        </StyledButton>
      </Form>

      <StyledLinkBlock>
        <span onClick={openForgotPassword}>{t('auth_forgot_password')}</span>
      </StyledLinkBlock>
    </FormWrapper>
  );
};

export default LogInForm;
